import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import { store } from "./store/_helpers";
import appConfig from "./appConfig";
import "./assets/scss/style.scss";
import "react-datepicker/dist/react-datepicker.css";

const app = (
  <Provider store={store}>
    <BrowserRouter basename={appConfig.basename}>
        <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

/*
**************ReactJS 18
import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App/index";
import * as serviceWorker from "./serviceWorker";

import { store } from "./store/_helpers";
import appConfig from "./appConfig";
import "./assets/scss/style.scss";
import reportWebVitals from "./reportWebVitals";

// const app = (
//   <Provider store={store}>
//     <BrowserRouter basename={appConfig.basename}>
//       <App />
//     </BrowserRouter>
//   </Provider>
// );

// ReactDOM.render(app, document.getElementById("root"));

/* NEW version React 
const root = createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={appConfig.basename}>
        <App />
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

*/
